import { ImportTemplateField } from "@/types";
import { DataType } from "../DataType";

export const Fund: ImportTemplateField[] = [
  {
    toField: "fundKey",
    fromField: "",
    dataType: DataType.string,
    required: true,
  },
  {
    toField: "name",
    fromField: "",
    dataType: DataType.string,
    required: true,
  },
];
